<div class="gap-6 flex flex-col overflow-hidden">
  <form [formGroup]="customerSchemeProviderForm">
    <div class="w-full flex flex-col bg-white rounded-xl pb-6 overflow-x-auto">
      <div >
      <div
        class="flex w-full justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
      >
        <div class="flex gap-4">
          <div class="h-10 w-1 bg-primary"></div>
          <span>Commission Configuration</span>
        </div>
      </div>
      <div class="p-5" *ngIf="resData == 'reseller'">
        <span>Schemes</span>
        <select
          (change)="onSchemeSelect($event)"
          formControlName="schemeId"
          name="schemeId"
          class="w-1/2 p-2 rounded-md outline-none border"
        >
          <option>Select Scheme</option>
          <option *ngFor="let scheme of schemeData" [value]="scheme?._id">
            {{ scheme?.schemeName }}
          </option>
        </select>
        <div class="text-red-500" *ngIf="
        (customerSchemeProviderForm.controls['schemeId'].touched &&
          !customerSchemeProviderForm.controls['schemeId'].valid)">
  Scheme is required
        </div>
      </div>
      <div *ngIf="((selectedScheme || customerSchemeProviderForm.get('schemeId')?.value)
       && resData == 'reseller') || resData !== 'reseller'"
        class="flex flex-col gap-6 w-full"
        
      >
      <!-- [ngStyle]="{ 'pointer-events': selectedScheme ? 'none' : 'all' }" -->
        <div class="w-full overflow-hidden">
          <div
            class="w-full bg-gray-300 justify-between flex items-center text-primary"
          >
            <span class="px-6 w-2/3">PayIn *</span>
            <span class="text-white p-2 w-1/3 bg-primary"
              >Your Scheme PayIn Charges</span
            >
          </div>
          <div class="w-full flex gap-6 p-5 overflow-x-auto">
            <div class="w-full flex flex-col gap-4">
              <span class="font-bold">Charge Type</span>
              <span *ngIf="resData == 'admin' || resData == 'reseller' || resData == 'partner'">
                 {{ customerSchemeProviderForm.get('chargeType')?.value | titlecase }}
                 </span>
              <select *ngIf="!allRoles.includes(resData)"
                class="border p-2 outline-none rounded-md"
                formControlName="chargeType"
              >
                <option value="" disabled>Select Charge Type</option>
                <option value="flat">Flat</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>
            <div
              *ngIf="resData == 'partner' || resData == 'admin'"
              class="w-full flex flex-col gap-4"
            >
              <span class="font-bold">Fintrax</span>
              <span *ngIf="resData == 'partner'">
                {{ customerSchemeProviderForm.get('payInFintrax')?.value }} </span>
              <input *ngIf="resData == 'admin'"
                [readonly]="
                  !customerSchemeProviderForm.get('chargeType')?.value
                "
                [max]="
                  customerSchemeProviderForm.get('chargeType')?.value ==
                  'percentage'
                    ? 100
                    : null
                "
                type="number"
                formControlName="payInFintrax"
                name="payInFintrax"
                class="border p-2 rounded-md outline-none"
                placeholder="Fintrax"
              />
            </div>
            <div
              *ngIf="
                resData == 'reseller' ||
                resData == 'partner' ||
                resData == 'admin'
              "
              class="w-full flex flex-col gap-4"
            >
              <span class="font-bold">Partner Charge</span>
              <span *ngIf="resData == 'reseller'">
                {{ customerSchemeProviderForm.get('payInPartner')?.value }} </span>
              <input *ngIf="resData == 'admin' || resData == 'partner'"
                [readonly]="
                  !customerSchemeProviderForm.get('chargeType')?.value
                "
                [max]="
                  customerSchemeProviderForm.get('chargeType')?.value ==
                  'percentage'
                    ? 100
                    : null
                "
                type="number"
                formControlName="payInPartner"
                name="payInPartner"
                class="border p-2 rounded-md outline-none"
                placeholder="Enter Partner Charge"
              />
            </div>
            <div
              class="w-full flex flex-col gap-4"
              *ngIf="
                (resData == 'reseller' ||
                resData == 'merchant' ||
                resData == 'admin') && currentUserRole !='reseller'
              "
            >
              <span class="font-bold">Reseller Charge</span>
              <span *ngIf="resData == 'reseller' && currentUserRole !='reseller'">
                {{ customerSchemeProviderForm.get('payInReseller')?.value }} </span>
              <input *ngIf="resData == 'admin' && currentUserRole !='reseller'"
                type="number"
                formControlName="payInReseller"
                name="payInReseller"
                class="border p-2 rounded-md outline-none"
                placeholder="Enter Reseller Charge"
              />
            </div>
            <!-- <div
              *ngIf="resData == 'merchant' || resData == 'admin'"
              class="w-full flex flex-col gap-4"
            >
              <span>Merchant Charge</span>
              <input
              formControlName="payInReseller"
              name="payInReseller"
                class="border p-2 rounded-md outline-none"
                placeholder=""
              /> -->
              <!-- </div> -->
            </div>
            <div
              *ngIf="
                (customerSchemeProviderForm.controls['payInFintrax'].touched &&
                  !customerSchemeProviderForm.controls['payInFintrax'].valid) ||
                (customerSchemeProviderForm.controls['payInReseller'].touched &&
                  !customerSchemeProviderForm.controls['payInReseller']
                    .valid) ||
                (customerSchemeProviderForm.controls['payInPartner'].touched &&
                  !customerSchemeProviderForm.controls['payInPartner'].valid)
              "
              class="text-red-500"
            >
              Invalid format. It should be a number with up to two decimal
              places.
            </div>
            <div
            *ngIf="customerSchemeProviderForm.errors?.['invalidOrders']"
            class="text-red-500"
          >
            Values must be in increasing order.
          </div>
          </div>
          <!-- PayOut -->
          <div class="gap-4 flex flex-col">
            <div
              class="w-full bg-gray-300 justify-between flex items-center text-primary"
            >
              <span class="px-6 w-2/3">PayOut *</span>
              <span class="text-white p-2 bg-primary w-1/3"
                >Your Scheme PayOut Charges</span
              >
            </div>
            <table class="w-full">
              <tr class="w-full border text-left">
                <th class="px-2">Range</th>
                <th class="px-2">Charge Type</th>
                <th
                  class="px-2"
                  *ngIf="resData == 'partner' || resData == 'admin'"
                >
                  Fintrax
                </th>
                <th
                  *ngIf="
                    resData == 'reseller' ||
                    resData == 'partner' ||
                    resData == 'admin'
                  "
                >
                  Partner Charge
                </th>
                <th
                  *ngIf="
                   ( resData == 'reseller' ||
                    resData == 'merchant' ||
                    resData == 'admin') && currentUserRole !='reseller'
                  "
                >
                  Reseller Charge
                </th>
                <!-- <th *ngIf="resData == 'merchant' || resData == 'admin'">  Merchant Charge
              
              </th> -->
            </tr>
            <tr *ngFor="let item of payOutTableData">
              <td class="border p-2">{{ item.range }}</td>
              <td class="border p-2">
               <span *ngIf="resData == 'admin' || resData == 'reseller' || resData == 'partner'">
                  {{ customerSchemeProviderForm.get(item.rangeChargeType)?.value | titlecase }} </span>
                <select *ngIf="!allRoles.includes(resData)"
                  [attr.disabled]="
                    resData == 'partner' || resData == 'reseller'
                  "
                  class="w-full outline-none"
                  [hidden]="resData == 'partner' || resData == 'reseller'"
                  [formControlName]="item.rangeChargeType"
                >
                  <option value="" disabled>Select Charge Type</option>
                  <option value="flat">Flat</option>
                  <option value="percentage">Percentage</option>
                </select>
              </td>
              <td
                *ngIf="resData == 'partner' || resData == 'admin'"
                class="border"
              >
              <span *ngIf="resData == 'partner'">
                {{ customerSchemeProviderForm.get(item.rangeChargeFintrex)?.value }} </span>
                <input *ngIf="resData == 'admin'"
                  [readonly]="
                    !customerSchemeProviderForm.get(item.rangeChargeType)?.value
                  "
                  [max]="
                    customerSchemeProviderForm.get(item.rangeChargeType)
                      ?.value == 'percentage'
                      ? 100
                      : null
                  "
                  type="number"
                  [formControlName]="item.rangeChargeFintrex"
                  placeholder=" {{ item.partner }}"
                  [name]="item.rangeChargeFintrex"
                  class="outline-none w-full"
                />
              </td>
              <td
                *ngIf="
                 ( resData == 'partner' ||
                  resData == 'admin' ||
                  resData == 'reseller')
                "
                class="border"
              >
              <span *ngIf="resData == 'reseller'">
                {{ customerSchemeProviderForm.get(item.rangeChargePartner)?.value }} </span>
                <input *ngIf="resData == 'admin' || resData == 'partner'"
                  type="number"
                  [readonly]="
                    !customerSchemeProviderForm.get(item.rangeChargeType)?.value
                  "
                  [max]="
                    customerSchemeProviderForm.get(item.rangeChargeType)
                      ?.value == 'percentage'
                      ? 100
                      : null
                  "
                  [formControlName]="item.rangeChargePartner"
                  [name]="item.rangeChargePartner"
                  placeholder=" {{ item.partner }}"
                  class="outline-none w-full"
                />
              </td>
              <td
                *ngIf="
                 ( resData == 'reseller' ||
                  resData == 'merchant' ||
                  resData == 'admin') && currentUserRole !='reseller'
                "
                class="border"
              >
              <span *ngIf="resData == 'reseller' && currentUserRole !='reseller'">
                {{ customerSchemeProviderForm.get(item.rangeChargeReseller)?.value }} </span>
                <input *ngIf="resData == 'admin' &&  currentUserRole !='reseller'"
                  class="outline-none w-full"
                  type="number"
                  [readonly]="
                    !customerSchemeProviderForm.get(item.rangeChargeType)?.value
                  "
                  min="0"
                  [max]="
                    customerSchemeProviderForm.get(item.rangeChargeType)
                      ?.value == 'percentage'
                      ? 100
                      : null
                  "
                  [formControlName]="item.rangeChargeReseller"
                  placeholder=" {{ item.partner }}"
                />
              </td>
              <!-- <td *ngIf=" resData == 'admin' || resData == 'merchant' " class="border">
                <input class="outline-none w-full" [formControlName]="item.rangeChargeMerchant"
                placeholder=" {{ item.partner }}"/>
              </td> -->
              </tr>
            </table>
            <div
              *ngIf="
                (customerSchemeProviderForm.controls['chargeFintraxOne']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeFintraxOne']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargeFintraxTwo']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeFintraxTwo']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargeFintraxThree']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeFintraxThree']
                    .valid)
              "
              class="text-red-500"
            >
              Invalid format or value
            </div>
            <div
              *ngIf="
                (customerSchemeProviderForm.controls['chargePartnerOne']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargePartnerOne']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargePartnerTwo']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargePartnerTwo']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargePartnerThree']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargePartnerThree']
                    .valid)
              "
              class="text-red-500"
            >
              Invalid format. It should be a number with up to two decimal
              places.
            </div>
            <div
              *ngIf="
                (customerSchemeProviderForm.controls['chargeResellerOne']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeResellerOne']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargeResellerTwo']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeResellerTwo']
                    .valid) ||
                (customerSchemeProviderForm.controls['chargeResellerThree']
                  .touched &&
                  !customerSchemeProviderForm.controls['chargeResellerThree']
                    .valid)
              "
              class="text-red-500"
            >
              Invalid format or value
            </div>
            <div
              *ngIf="customerSchemeProviderForm.errors?.['invalidOrder']"
              class="text-red-500"
            >
              Values must be in increasing order.
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="currentUserRole == 'merchant'" class="w-full">
        <div
          class="flex w-full pt-10 justify-between rounded-t-xl py-4 pr-4 border-transparent border-[2px] border-b-gray-300"
        >
          <div class="flex gap-4">
            <div class="h-10 w-1 bg-primary"></div>
            <span class="flex items-center gap-4"
              >Providers
              <span class="text-[12px] text-primary"
                >(Ensure your partner has been assigned a provider to access the
                list.)</span
              >
            </span>
          </div>
        </div>
        <!-- <div class="p-5 h-20">
      <span>Provider</span>
      <select
        (change)="onClick($event)"
        class="w-1/2 p-2 rounded-md outline-none border"
      >
        <option>Providers</option>
        <option *ngFor="let item of providerData" [value]="item._id">
          {{ item.providerName }}
        </option>
      </select> -->
        <!-- </div> -->
        <div
          class="p-5 h-20"
          [ngStyle]="{
            'pointer-events':
              resData == 'admin' || resData == 'partner' ? 'none' : 'all'
          }"
        >
          <span>PayIn</span>
          <select
            formControlName="providerPayIn"
            name="providerPayIn"
            (change)="onProviderPayInSelect($event)"
            class="w-1/2 p-2 rounded-md outline-none border"
          >
          <option  value="" >
            --Select PayIn--
          </option>
            <option *ngFor="let item of providerDataPayin" [value]="item._id">
              {{ item.providerName }}
            </option>
          </select>
          <div
            class="text-red-500"
            *ngIf="
              customerSchemeProviderForm.controls['providerPayIn'].touched &&
              !customerSchemeProviderForm.controls['providerPayIn'].valid
            "
          >
            PayIn is required
          </div>
        </div>
        <div
          class="p-5 h-20"
          [ngStyle]="{
            'pointer-events':
              resData == 'admin' || resData == 'partner' ? 'none' : 'all'
          }"
        >
          <span>PayOut</span>
          <select
            formControlName="providerPayOut"
            name="providerPayOut"
            (change)="onProviderPayoutSelect($event)"
            class="w-1/2 p-2 rounded-md outline-none border"
          >
          <option value="" >--Select PayOut--</option>
            <option *ngFor="let item of providerDataPayout" [value]="item._id">
              {{ item.providerName }}
            </option>
          </select>
          <div
            class="text-red-500"
            *ngIf="
              customerSchemeProviderForm.controls['providerPayOut'].touched &&
              !customerSchemeProviderForm.controls['providerPayOut'].valid
            "
          >
            PayOut is required
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
